export default "/images/8285aa0afd5d4659b814e6708092eb3c.avif";